import { Theme } from '@mui/material/styles/createTheme';

import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles<Theme>()((theme) => ({
  settingsWrapper: {
    backgroundColor: theme.palette.background.paper,
    borderRadius: '4px',
    padding: '8px',
    marginTop: '8px',
  },
  tabsContent: {
    margin: '4px 0',
  },
}));
